import React, { Fragment } from 'react'
import moment from 'moment'
const InfoCard = (props) => {
    const {
        recommended_vehicle = {},
        tentative_pickup_date
    } = props
    return (
        <Fragment>
            <div className='flex flex-middle gap-20'>
                <div>
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Recommended Vehicle Type :
                    </div>
                    <div className="header-medium-color  fs-16 mb-5">
                        {recommended_vehicle.vehicle_type_name || '-'}
                    </div>
                </div>
                <div>
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Tentative Pick Up Date :
                    </div>
                    <div className="header-medium-color  fs-16 mb-5">
                        {!!tentative_pickup_date ? moment(tentative_pickup_date).format('DD/MM/YYYY') : '-'}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default InfoCard